import {
  getHomePageHighlightVideoClips,
  HighlightVideoClipsResponse,
} from 'api/podcast';
import { podcastClipSelector } from 'api/selectors/podcast';
import { useCallback } from 'react';
import { InfiniteData, useInfiniteQuery } from 'react-query';
import { UseInfiniteQueryOptions } from 'types';
import { podcastHighlightsQueryKeys } from './queries';

export type UseHighlightVideoClipsOptions<TData = HighlightVideoClipsResponse> =
  UseInfiniteQueryOptions<
    HighlightVideoClipsResponse,
    ReturnType<typeof podcastHighlightsQueryKeys.homepage>,
    unknown,
    TData
  >;

export default function useGetHomePageHighlightVideoClips<
  TData = HighlightVideoClipsResponse,
>(opts?: UseHighlightVideoClipsOptions<TData>) {
  return useInfiniteQuery(
    podcastHighlightsQueryKeys.homepage(),
    ({ pageParam }) =>
      getHomePageHighlightVideoClips({
        nextClipUpdatedAtMillis: pageParam,
      }),
    {
      ...opts,
      enabled: opts?.enabled ?? true,
      getNextPageParam: (lastPage) =>
        lastPage?.nextClipUpdatedAtMillis ?? undefined,
    },
  );
}

export function useHomepageHighlightClip(clipId: number) {
  const { data, ...rest } = useGetHomePageHighlightVideoClips({
    select: useCallback(
      (d: InfiniteData<HighlightVideoClipsResponse>) =>
        podcastClipSelector(d, clipId),
      [clipId],
    ),
  });

  return { data: data?.pages[0], ...rest };
}
